import {
  FeedTblCol,
  FeedTblRow,
  TAssetBatch,
} from "shared/types/assetExporter";
import { IArtboard } from "shared/types/designStudio";

export enum ExportDestination {
  AdLibrary = "adLibrary",
  CSVDownload = "csv",
  GoogleSpreadsheet = "googleSpreadsheet",
}

export enum AdType {
  Still = "Still",
  Video = "Video",
}

export enum RecommendedColumnTitle {
  InFeedMedia = "In feed Image (1:1)",
  StoryMedia = "Story (9:16)",
  AdName = "Ad Name",
  PrimaryText = "Primary Text",
  Headline = "Headline",
  Description = "Description",
  UTM = "UTM",
  Brand = "Brand",
  Account = "Account",
  CTAButton = "CTA Button",
  DisplayURL = "Display URL",
  DestinationURL = "Destination URL",
}

export enum PortalOptions {
  Filters = "Filters",
  Metadata = "Metadata",
  DoNotImport = "DoNotImport",
  Filename = "filename",
}

export enum FillAdInfoColumnTitle {
  InFeedMedia = "1:1",
  StoryMedia = "9:16",
  AdName = "Ad Name",
  DisplayURL = "Display URL",
  DestinationURL = "Destination URL",
  PrimaryText = "Primary Text",
  Headline = "Headline",
  Description = "Description",
  CTAButton = "CTA Button",
  UTM = "UTM",
  Brand = "Brand",
  Account = "Account",
}

export type RecommendedColumnTitles = Record<string, RecommendedColumnTitle[]>;

export interface RecommendedColumnMatch {
  recommendedColumnTitle: RecommendedColumnTitle | null;
  namingRulePattern?: string;
  assetBatchName?: string;
  assetBatchId?: string;
  assetBatchCreatedAt?: number;
}

export interface PortalOptionMatch {
  portalOption: PortalOptions | null;
}

export interface PortalOptionMatchTableData {
  title: string;
  key: string;
  rowType: RowType;
}

export type RecommendedColumnMatches = Record<string, RecommendedColumnMatch>;

export type PortalOptionMatches = Partial<Record<string, PortalOptionMatch>>;

export enum RowType {
  Feed = "Feed",
  AssetName = "Asset Name",
  AssetBatch = "Asset Batch",
  Media = "Media",
}

export type MatchColumnsTableData = {
  title: string;
  key: string;
  rowType: RowType;
  tooltipText?: string;
  thumbnailURL?: string;
  isValidDimensions?: boolean;
  assetBatchName?: string;
  assetBatchId?: string;
};

export type GetMatchColumnsTableData = ({
  assetBatches,
  selectedAssetBatches,
  feedColumns,
  artboards,
  selectedRows,
}: {
  assetBatches: TAssetBatch[];
  selectedAssetBatches: string[];
  feedColumns: FeedTblCol[];
  artboards: IArtboard[] | undefined;
  selectedRows: string[];
}) => MatchColumnsTableData[];

export type FillAdInfoTableData = Partial<
  Record<FillAdInfoColumnTitle, string | null>
>;

export type AdInfoUpdates = Record<string, FillAdInfoTableData>;

export type GetFillAdInfoTableData = ({
  assetBatchesForSelectedRows,
  data,
  feedName,
  feedId,
  columnMatches,
  adType,
  page,
  adInfoUpdates,
}: {
  assetBatchesForSelectedRows: TAssetBatch[];
  data: FeedTblRow[];
  feedName: string;
  feedId: string;
  columnMatches: RecommendedColumnMatches;
  adType: AdType;
  page: number;
  adInfoUpdates: AdInfoUpdates;
}) => FillAdInfoTableData[];

export type HandleSelectColumnMatch = (
  recommendedColumnTitle: RecommendedColumnTitle,
  rowData: MatchColumnsTableData,
) => void;

export enum ExportToAdLibrarySteps {
  ExportSettings,
  MatchColumns,
  FillAdInfo,
}

export interface AssetBatchExportData {
  name: string;
  id: string;
  containsHTMLTemplates: boolean;
}

export type HandleSelectPortalOptions = (
  portalOption: PortalOptions,
  rowData: PortalOptionMatchTableData,
) => void;
